import config from 'config'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import history, { redirectToPage } from 'srcReact/helpers/history'
import styles from './styles.module.scss'
import LinkButton from '../../LinkButton'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import MobileHeader from 'srcReact/components/common2/Navigation/Header/components/MobileHeader'
import ReactMenu from '../../ReactMenu'

class HeaderLogout extends Component {
  constructor(props) {
    super(props)
    const { t } = this.props
    this.header = React.createRef()
    this.header2 = React.createRef()

    this.learnMoreItems = [
      {
        text: t('header.link4'),
        href: `/contact-us`
      },
      {
        text: t('header.link2'),
        href: `${config.webUrl}/communities-at-work/learn-more/about`,
        isNotReactLink: true
      },
      {
        text: t('header.link3'),
        href: `${config.webUrl}/blog/communities`,
        isNotReactLink: true
      },
      {
        text: t('header.press'),
        href: `${config.webUrl}/communities-at-work/learn-more/press`,
        isNotReactLink: true
      }
    ]

    this.solutionItems = [
      {
        text: t('nav.sustainable-productivity'),
        href: `https://community.mixr.net/solution-pages/sustainable-productivity`,
        isNotReactLink: true
      },
      {
        text: t('global.engagement'),
        href: `https://community.mixr.net/solution-pages/employee-engagement`,
        isNotReactLink: true
      },
      {
        text: t('nav.onboarding'),
        href: `https://community.mixr.net/solution-pages/onboarding`,
        isNotReactLink: true
      },
      {
        text: t('nav.employee-retention'),
        href: `https://community.mixr.net/solution-pages/employee-retention`,
        isNotReactLink: true
      },
      {
        text: t('nav.wellbeing'),
        href: `https://community.mixr.net/solution-pages/nurture-employee-wellbeing-in-the-age-of-hybrid-work`,
        isNotReactLink: true
      }
    ]
  }

  componentDidMount() {
    if (
      !window.hasOwnProperty('__PRERENDER_INJECTED') &&
      this.header.current != null &&
      this.header.current.classList.contains('d-none')
    ) {
      this.header.current.classList.remove('d-none')
    }
    if (
      !window.hasOwnProperty('__PRERENDER_INJECTED') &&
      this.header2.current != null &&
      this.header2.current.classList.contains('d-none')
    ) {
      this.header2.current.classList.remove('d-none')
    }
  }

  handleLink(pagePath) {
    redirectToPage(`/${pagePath}`, this.props.isNative)
  }

  handleKeyDown(e, pagePath) {
    if (e && e.keyCode === 13) {
      this.handleLink(pagePath)
    }
  }

  render() {
    const { t, user, loggedIn, isNative, isPlain, isMobile } = this.props
    const location = history.location.pathname
    const includeLoginBtn = location.match('signup')
    return isMobile ? (
      <header ref={this.header} className={`site-header-mobile position-relative ${isNative ? 'is-native' : ''}`}>
        <MobileHeader />
      </header>
    ) : (
      <header ref={this.header2} className={`site-header ${styles.mainHeader}`}>
        <a
          className={`${styles.brand} ${isPlain ? styles.brandPlain : ''}`}
          hhref={isUserAuthorized() ? config.webUrl : 'https://community.mixr.net/'}>
          {/* // href={isUserAuthorized() ? config.webUrl : config.webUrl + '/communities-at-work'}> */}
          <img
            className={styles.logoImage}
            src={`${config.assetUrl}/images/logo-mixr.png`}
            alt='MixR Home'
            height='30'
          />
        </a>
        {includeLoginBtn && (
          <LinkButton href='/auth' reactLink={!isNative} customStyle={styles.loginButton} text={t('global.login')} />
        )}

        <nav>
          {!isPlain && (
            <ul className={styles.nav} id='main_menu'>
              <li className={styles.navItem}>
                <a aria-label={`${t('header.link0')}`} className={styles.navItemLink} href='/'>
                  {t('header.link0')}
                </a>
              </li>
              <li className={styles.navItem}>
                <a className={styles.navItemLink} href={'https://community.mixr.net/product'}>
                  {t('header.link1')}
                </a>
              </li>
              <li className={styles.navItem}>
                <ReactMenu
                  isHoverMenu={true}
                  buttonText={t('nav.solutions')}
                  options={this.solutionItems}
                  menuButtonCSS={styles.dropdownButton}
                  menuCSS={`${styles.dropdownMenu} ${styles.dropdownMenuBottomRight} ${styles.dropdownMenuWidth220}`}
                  menuItemCSS={styles.dropdownMenuItem}
                  buttonIconPosition='end'
                  buttonIcon='chevron-down24'
                />
              </li>
              <li className={styles.navItem}>
                <ReactMenu
                  isHoverMenu={true}
                  buttonText={t('nav.learnMore')}
                  options={this.learnMoreItems}
                  menuButtonCSS={styles.dropdownButton}
                  menuCSS={`${styles.dropdownMenu} ${styles.dropdownMenuBottomRight} ${styles.dropdownMenuWidth120}`}
                  menuItemCSS={styles.dropdownMenuItem}
                  buttonIconPosition='end'
                  buttonIcon='chevron-down24'
                />
              </li>
              <li className={styles.navItem}>
                <a
                  tabIndex='0'
                  className={styles.navItemLink}
                  onKeyDown={(e) => this.handleKeyDown(e, '0/pricing')}
                  onClick={() => this.handleLink('0/pricing')}>
                  {t('nav.pricing')}
                </a>
              </li>

              {loggedIn ? (
                <li className={styles.navItem}>
                  <LinkButton text={t('header.home')} style='secondary' size='medium' href={`${config.webUrl}`} />
                </li>
              ) : (
                <React.Fragment>
                  <li className={`${styles.navItem} ${styles.signupListItem}`}>
                    <LinkButton
                      text={t('header.signup')}
                      style='secondary'
                      size='medium'
                      customStyle={styles.signupButton}
                      href={`${config.webUrl}/0/signup`}
                    />
                  </li>
                  {!this.props.nosignup && (
                    <li className={styles.navItem}>
                      <LinkButton
                        text={t('header.login')}
                        style='tertiary'
                        size='medium'
                        href='/auth'
                        customStyle={styles.loginButton}
                      />
                    </li>
                  )}
                </React.Fragment>
              )}
            </ul>
          )}
        </nav>
      </header>
    )
  }
}

function mapStateToProps(state) {
  const { login, common } = state
  const { user, loggedIn } = state.login
  const { isNative, isMobile } = common
  return { user, loggedIn, isNative, isMobile }
}
const ExtendedComponent = withTranslation('common')(HeaderLogout)

const connectedHeaderLogout = connect(mapStateToProps)(ExtendedComponent)
export { connectedHeaderLogout as HeaderLogout }
